import { render, staticRenderFns } from "./DiamondHole.vue?vue&type=template&id=c5389682&scoped=true"
import script from "./DiamondHole.vue?vue&type=script&lang=js"
export * from "./DiamondHole.vue?vue&type=script&lang=js"
import style0 from "./DiamondHole.vue?vue&type=style&index=0&id=c5389682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5389682",
  null
  
)

export default component.exports